/*
* @Description: 合作意向 查看弹出层
* @Author: lqt
* @Date: 2021-5-12 10:47:44
*/
<template>
  <el-dialog title="查看" :visible.sync="visible" @close="handleClose" width="600px">
    <el-form label-width="200px">
      <el-form-item label="联融涉及相关方或相关单位">
        <el-row class="text">{{form.company}}</el-row>
      </el-form-item>
      <el-form-item label="联系人">
        <el-row class="text">{{form.name}}</el-row>
      </el-form-item>
      <el-form-item label="联系电话">
        <el-row class="text">{{form.phone}}</el-row>
      </el-form-item>
      <el-form-item label="意向合作项目">
        <el-row class="text">{{form.lrProject}}</el-row>
      </el-form-item>
      <el-form-item label="发起时间">
        <el-row class="text">{{form.createTime}}</el-row>
      </el-form-item>
      <el-form-item label="状态">
        <el-row class="text">{{form.status === 0 ? '未受理' : '已受理'}}</el-row>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import ImgView from '@/components/imgView'

export default {
  name: 'checkDialog',
  components: { ImgView },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      trustData: [],
      pageSize: 1,
      pageNo: 1,
      total: 2,
      visible: this.show,
      form: {},
      formLabelWidth: '100px'
    }
  },
  methods: {
    handleClose () {
      this.$emit('update:show', false)
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      if (newVal) {
        this.form = { ...this.formData }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .text {
    color: $primary-font-color-light;
    font-size: 12px;
  }
  .img-view {
    width: 150px;
    height: 150px;
    margin-right: 10px;
    float: left;
  }
  .tip {
    color: #ccc;
    font-size: 12px;
  }
  .pagination{
    text-align: center;
  }
</style>
